import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CustomerPartNumberState from "@tSchaedlerYesco/Store/Data/CustomerPartNumber/CustomerPartNumberState";
import { CustomerPartNumberModel } from "@tSchaedlerYesco/Types/CustomAPIModels";
import { Draft } from "immer";

const initialState: CustomerPartNumberState = {
    isLoading: false,
    value: <CustomerPartNumberModel>{},
};

const reducer = {
    "Data/CustomerPartNumber/BeginLoadCustomerPartNumber": (draft: Draft<CustomerPartNumberState>) => {
        draft = {
            isLoading: true,
        };
    },
    "Data/CustomerPartNumber/CompleteLoadCustomerPartNumbers": (
        draft: Draft<CustomerPartNumberState>,
        payload: { action: CustomerPartNumberModel },
    ) => {
        draft.value = payload.action;
    },
    "Data/CustomerPartNumber/Add": (
        draft: Draft<CustomerPartNumberState>,
        payload: { action: CustomerPartNumberModel },
    ) => {
        draft.value = payload.action;
    },
    "Data/CustomerPartNumber/Delete": (
        draft: Draft<CustomerPartNumberState>,
        action: { result: CustomerPartNumberModel },
    ) => {
      draft.value;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
